var Aneox;
(function(Aneox) {
    (function(Controllers) {
        'use strict';

        var Home = (function() {

            var self;

            function Home(animations) {
                self = this;
                self.timeline = animations.timeline;
                self.gallery = '.gallery';
            }

            Home.prototype.enter = function() {
                self.timeline.set('#home', { display: 'block', opacity: 0 });
                self.timeline.to('#home', 0.5, { opacity: 1 });

                $(self.gallery + ' .background-gallery-menu li').removeClass('active');
                $(self.gallery + ' .background').removeClass('active');
                $(self.gallery + ' .background-gallery-menu li:first-child').addClass('active');
                $(self.gallery + ' .background:first-child').addClass('active');

                 self.galleryInterval = setInterval(self.nextGalleryImage.bind(self, true), 3333);
            };

            Home.prototype.leave = function() {
                
                if (self.galleryInterval !== undefined) {
                    clearInterval(self.galleryInterval);
                    self.galleryInterval = undefined;
                }
                self.timeline.to('#home', 0.5, { display: 'none', opacity: 0 });
            };

            Home.prototype.handleWindowResize = function() {        
            };
            
            Home.prototype.previousGalleryImage = function(isInterval) {
                if (isInterval !== true && self.galleryInterval !== undefined) {
                    clearInterval(self.galleryInterval);
                    self.galleryInterval = undefined;
                }

                var index = $(''+ self.gallery +' .background-gallery-menu li.active').index();
                var total = $(''+ self.gallery +' .background-gallery-menu li').length;
                
                index -= 1;
                if (index < 0) index = total - 1;
                
                self.setGalleryImage(index, isInterval);
            };

            Home.prototype.nextGalleryImage = function(isInterval) {
                if (isInterval !== true && self.galleryInterval !== undefined) {
                    clearInterval(self.galleryInterval);
                    self.galleryInterval = undefined;
                }
                
                var index = $(''+ self.gallery +' .background-gallery-menu li.active').index();
                var total = $(''+ self.gallery +' .background-gallery-menu li').length;
                
                index += 1;
                if (index >= total) index = 0;
                
                self.setGalleryImage(index, isInterval);
            };

            Home.prototype.setGalleryImage = function(index, isInterval) {
                if (isInterval !== true && self.galleryInterval !== undefined) {
                    clearInterval(self.galleryInterval);
                    self.galleryInterval = undefined;
                }

                $(''+ self.gallery +' .background-gallery-menu li').removeClass('active');
                $(''+ self.gallery +' .background').removeClass('active');
                    
                $(''+ self.gallery +' .background-gallery-menu li:eq(' + index + ')').addClass('active');
                $(''+ self.gallery +' .background:eq(' + index + ')').addClass('active');
            };

            return Home;
        })();

        Controllers.Home = Home;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));
